import { StrictMode } from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";

// project-import
import reportWebVitals from './reportWebVitals';
import App from './App';
import { store } from './store/store';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
    <StrictMode>
        <Provider store={store}>  {/* changes for data persistancy throughout the LSA Project, adding store in provider */}
            <ParallaxProvider>
                <App />
            </ParallaxProvider>
        </Provider>
    </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();